export default {
  name: "Profile",
  path: "/profile",
  component: () => import("@/views/Profile")
};
